var ddbViewerParams = {
  ddbViewerParamsFilePath: "ddbViewerParams.json",
  data: {}
};

ddbViewerParams.init = function(callback) {
  $.ajax({
    url: ddbViewerParams.ddbViewerParamsFilePath
    , global: false
    , dataType: "json"
    , async: true
    , success: function success(dataAjax, textStatusAjax, jqXHRAjax) {
      ddbViewerParams.data = dataAjax;
      callback.apply(this, []);
    }
    , error: function fail() {
      callback.apply(this, []);
    }
  });
}
